// Suppress ga undefined error
import Logman from "./logman";
/* eslint-disable no-undef */
export default class GoogleAnalytics {
  static pageView(sourceType) {
    let page = window.location.pathname + window.location.search;
    page = `${page}${
      page.indexOf("?") === -1 ? `?type=${sourceType}` : `&type=${sourceType}`
    }`;
    ga("send", "pageview", page);
  }

  static setDimension(dimension, value) {
    ga("set", dimension, value);
  }

  static trackEvent({
    category,
    action,
    label = `source=${window.pageType}`,
    interaction = false,
    toLogman = false,
    logmanEventName = "",
    ...otherParams
  }) {
    if (toLogman) {
      Logman.trackLog(arguments[0]);
    }

    ga("send", {
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      nonInteraction: interaction,
      ...otherParams,
    });
  }
}



// WEBPACK FOOTER //
// ./src/analytics/GoogleAnalytics.js